import { observer } from 'mobx-react-lite';

import PaymentMethods2 from './PaymentMethods2/PaymentMethods2';

const PaymentPanel = () => {
  return <PaymentMethods2 hideDisclaimer={true} />;
};

export default observer(PaymentPanel);
